import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SessionModalService {
    isOpen = signal(false);
    message = signal('');
    expiresAt = signal<number | undefined>(undefined);

    show(message: string, expiresAt?: number) {
        this.message.set(message);
        this.expiresAt.set(expiresAt);
        this.isOpen.set(true);
    }

    hide() {
        this.isOpen.set(false);
    }
}
